import { InformationActionTypes } from '@core/store';
import { Action, ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from 'environments/environment';

// tslint:disable-next-line:no-empty-interface
export interface State {}

export const reducers: ActionReducerMap<State> = {};

export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
  return function(state: State, action: any): State {

    // switch (action.type) {
    //   case InformationActionTypes.DismissBanner:
    //     //console.log('state', state);
    //     //console.log('action', action);
    // }
    // console.log('state', state);
    // console.log('action', action);

    return reducer(state, action);
  };
}

//export function persistStateReducer(_reducer: ActionReducer<State>) {
//  const localStorageKey = '__banner';
//  return (state: State | undefined, action: Action) => {
//    if (state === undefined) {
//      const persisted = localStorage.getItem(localStorageKey);
//      return persisted ? JSON.parse(persisted) : _reducer(state, action);
//    }

//    const nextState = _reducer(state, action);
//    localStorage.setItem(localStorageKey, JSON.stringify(nextState));
//    return nextState;
//  };
//}

// export function storageMetaReducer<S, A extends Action = Action>(reducer: ActionReducer<S, A>) {
//   return function(state: S, action: A): State {
//     const sessionStorageKey = '__banner';

//     const nextState = reducer(state, action);
//     const savedState = JSON.parse(localStorage.getItem(sessionStorageKey)) || {};
//     merge(nextState, savedState);
//     sessionStorage.setItem(sessionStorageKey, JSON.stringify(nextState));
//     return nextState;
//   };
// }

export const metaReducers: MetaReducer<State>[] = !environment.production ? [logger] : [];
